import api from 'api';
import { getAllLeafKeys } from './buildProductTree';



let typesRaw = {
	SET_STATE: 'SET_STATE',
	RESET_ALL: 'RESET_ALL',
};

export const types = Object.keys(typesRaw).reduce((all, key) => ({
	...all,
	[ key ]: `CUSTOMER_MANAGEMENT/CATALOG/${typesRaw[ key ]}`,
}), {});



const initialState = {
	loading: false,
	loaded: false,
	loadedCardCode: null,

	products: [],
	customerCategories: [],

	searchText: '',
	checkedKeys: [],
	treeInitialized: false,
	// 'all' | 'active' | 'inactive'
	inactiveMode: 'all',
	// 'all' | 'with' | 'missing'
	imageMode: 'all',
};




export const reducers = (state = initialState, action) => {
	switch (action.type) {
		case types.SET_STATE:
			return {
				...state,
				...action.data,
			};

		case types.RESET_ALL:
			return { ...initialState };

		default:
			return state;
	}
};




export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),



	reset_all: () => ({ type: types.RESET_ALL }),



	setSearchText: (searchText) => ({ type: types.SET_STATE, data: { searchText } }),



	setCheckedKeys: (checkedKeys) => ({ type: types.SET_STATE, data: { checkedKeys } }),



	loadCatalog: (cardCode) => async (dispatch, getState) => {
		if(!cardCode || getState().cm_catalog.loading) {
			return false;
		}

		dispatch(actions.setState({ loading: true, loaded: false }));

		try {
			let response = await api.get('/bp/catalog', {
				params: {
					bp_id: cardCode,
				},
			});

			const products = ((response && response.products) || []).slice().sort((a, b) =>
				String(a.model_label || a.model_description || '').localeCompare(String(b.model_label || b.model_description || ''))
			);

			const customerCategories = (response && response.customer_categories) || [];

			const data = {
				loading: false,
				loaded: true,
				loadedCardCode: cardCode,
				products: products,
				customerCategories: customerCategories,
			};

			// Default every category toggle to on the first time this BP loads
			if (!getState().cm_catalog.treeInitialized) {
				data.checkedKeys = getAllLeafKeys(products, customerCategories);
				data.treeInitialized = true;
			}

			dispatch(actions.setState(data));
		} catch(err) {
			console.error(err);
			dispatch(actions.setState({ loading: false, loaded: true, products: [] }));
		}
	},
};
